import useDispensary from 'src/dispensary/hooks/use-dispensary';

/**
 * Hook to check if product urgency messaging is enabled for the dispensary
 * This checks only the store settings
 */
export function useProductUrgencyEnabled(): boolean {
  const { dispensary } = useDispensary();

  if (!dispensary) {
    return false;
  }

  return dispensary?.storeSettings?.enableProductUrgencyMessaging ?? false;
}
